<template>
  <el-dialog
    class="dialog"
    title="班级学员管理"
    width="50%"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    distroy-on-close
  >
    <div>
      <div class="left-panel">
        <el-input
          size="small"
          v-model="query"
          prefix-icon="el-icon-search"
          placeholder="请输入学员姓名"
          @input="queryMember"
        ></el-input>
        <el-tree
          class="member-tree"
          ref="memberTree"
          show-checkbox
          :default-expanded-keys="checkData"
          check-on-click-node
          node-key="id"
          :data="memberData"
          :load="loadNode"
          @check-change="checkAction"
          lazy
          :props="{
            children: 'children',
            label: 'typeName',
            isLeaf: isLeaf,
          }"
          :filter-node-method="filterNode"
        ></el-tree>
      </div>
      <div class="right-panel">
        <div class="panel-header">
          <span>已选中{{ selectedMembers.length }}人</span>
          <el-button
            type="text"
            :disabled="selectedMembers.length == 0"
            @click="clear"
            >清空
          </el-button>
        </div>
        <ul class="member-list">
          <li v-for="(member, index) in selectedMembers" :key="member.id">
            <div>
              <span>{{ member.typeName }}</span>
              <i
                class="el-icon-close"
                style="float: right; cursor: pointer"
                @click="deleteMember(index)"
              ></i>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close" size="small">取消</el-button>
      <el-button type="primary" size="small" @click="confirm">确认</el-button>
    </span>
  </el-dialog>
</template>

<script>
import vue from "@/main";
import { lazyTreeUserForClass } from "@/api/enrollment";
import { saveStudent, getStudentList } from "@/api/enrollment";

export default {
  data() {
    return {
      dialogVisible: false,
      query: "",
      classId: "",
      memberData: [],
      selectedMembers: [],
      checkData:[],
    };
  },
  created() {
    vue.$on("selectMember", (classId) => {
      this.dialogVisible = true;
      this.classId = classId;
      this.getStudentList();
      // this.getMembers();
    });
  },
  methods: {
    isLeaf (data, node) {
      return data.type === '1'
    },
    loadNode(node, resolve) {
      lazyTreeUserForClass({ classId: this.classId, deptId: node.data.deptId }).then(
        (res) => {
          if (!res || res.code != 0) return;
          resolve(res.data);
        }
      );
    },
    // 获取名单树
    getMembers() {
      lazyTreeUserForClass({ classId: this.classId }).then((res) => {
        if (!res || res.code != 0) return;
        this.memberData = res.data;
        this.getStudentList();
      });
    },
    // 报名成功的学员列表（用于学员管理回显）
    getStudentList() {
      getStudentList(this.classId).then((res) => {
        if (!res || res.code != 0) return;
        this.aa=res.data;
        this.$refs["memberTree"].setCheckedKeys(res.data);
      });
    },
    checkAction(data, checked, node) {
      // 获取所有选中的叶子节点
      const array = this.$refs["memberTree"].getCheckedNodes(true);
      this.selectedMembers = array.filter((ele) => ele.type == 1);
    },
    // 搜索考试成员
    queryMember(val) {
      this.$refs.memberTree.filter(val);
    },
    // 清空
    clear() {
      this.$refs["memberTree"].setCheckedKeys([]);
    },
    // 删除选中人员
    deleteMember(index) {
      this.selectedMembers.splice(index, 1);
      this.$refs["memberTree"].setCheckedNodes(this.selectedMembers);
    },
    // 搜索符合条件的考试人员，只搜索人员
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1 && data.type == 1;
    },
    // dialog关闭时重置状态
    close() {
      this.clear();
      this.$nextTick(() => {
        this.dialogVisible = false;
      });
    },
    confirm() {
      if (this.selectedMembers.length === 0) {
        this.$message({
          message: "请选择学员",
          type: "warning",
        });
      } else {
        saveStudent({
          classId: this.classId,
          userIdList: this.selectedMembers.map((ele) => ele.id),
        }).then((res) => {
          if (!res || res.code != 0) return;
          this.$message({
            message: "新增成功",
            type: "success",
          });
          vue.$emit("tableInit");
          this.close();
        });
      }
    },
  },
  beforeDestroy() {
    vue.$off("selectMember");
  },
};
</script>

<style lang="scss" scoped>
$text-color: #51627d;
$text-font: 14px;
@mixin text {
  color: $text-color;
  font-size: $text-font;
}

@mixin border {
  border: 1px solid #d7dbe0;
  border-radius: 2px;
}

@mixin panel {
  width: 48%;
  height: 300px;
  box-sizing: border-box;
  overflow: hidden;
}

.dialog {
  /deep/ .el-dialog__body {
    max-height: auto;

    .left-panel {
      float: left;
      @include border;
      padding: 10px;
      @include panel;
    }

    .right-panel {
      float: right;
      @include border;
      @include panel;
    }

    .member-tree {
      margin-top: 10px;
      height: calc(100% - 42px);
      overflow-y: auto;

      /deep/ .el-tree-node__label {
        @include text;
      }
    }

    .panel-header {
      background-color: #f2f3f4;
      height: 44px;
      display: flex;
      padding: 0 15px;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      & > span:first-child {
        @include text;
      }
    }

    .member-list {
      height: calc(100% - 64px);
      overflow-y: auto;
      margin: 10px 0;
      padding: 0 10px;

      li {
        list-style: none;
        padding: 8px 10px;
        @include text;

        &:hover {
          background-color: #3a85ff;
          color: #fff;
        }
      }
    }
  }
}
</style>
